import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import {
  DxDataGridModule,
  DxButtonModule,
  DxToolbarModule,
  DxTextBoxModule,
  DxValidatorModule,
  DxSelectBoxModule,
  DxPopupModule,
  DxLoadIndicatorModule,
  DxScrollViewModule,
  DxProgressBarModule,
  DxMenuModule,
  DxTagBoxModule,
  DxDropDownButtonModule,
  DxListModule,
  DxDateBoxModule,
  DxCheckBoxModule,
  DxColorBoxModule
} from "devextreme-angular";
import { UserImageComponent } from "./user-image/user-image.component";
import { FunctionalitiesGridComponent } from "./functionalities-grid/functionalities-grid.component";
import { UsecasesGridComponent } from "./usecases-grid/usecases-grid.component";
import { AssetCategoryEditorComponent, FunctionalitiesFormComponent, UsecasesFormComponent } from "../demo-asset-editor";
import { DomainGridComponent } from "./domain-grid/domain-grid.component";
import { ProcessGridComponent } from "./process-grid/process-grid.component";
import { GroupGridComponent } from "./group-grid/group-grid.component";
import { IndustryGridComponent } from "./industry-grid/industry-grid.component";
import { ReactiveFormsModule } from "@angular/forms";
import { NavbarComponent } from "./navbar/navbar.component";
import { MatIconModule } from "@angular/material/icon";
import { DemosGridComponent } from "./demos-grid/demos-grid.component";
import { NavbarFooterComponent } from "./navbar-footer/navbar-footer.component";
import { HeroImageComponent } from "./hero-image/hero-image.component";
import { ContactSupportComponent } from "./contact-support/contact-support.component";
import { MatButtonModule } from "@angular/material/button";
import { TemplateDialogComponent } from "./template-dialog/template-dialog.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { FilterDropdownComponent } from "./filter-dropdown/filter-dropdown.component";
import { SFAccountGridComponent } from "./sfaccount-grid/sfaccount-grid.component";
import { MaintenancePopupComponent } from "./maintenance-popup/maintenance-popup.component";
import { MaintenanceAlertComponent } from "./maintenance-alert/maintenance-alert.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ButtonWrapperComponent } from "./button-wrapper/button-wrapper.component";

@NgModule({
  declarations: [
    UserImageComponent,
    DemosGridComponent,
    FunctionalitiesGridComponent,
    UsecasesGridComponent,
    FunctionalitiesFormComponent,
    UsecasesFormComponent,
    DomainGridComponent,
    ProcessGridComponent,
    GroupGridComponent,
    IndustryGridComponent,
    NavbarComponent,
    NavbarFooterComponent,
    HeroImageComponent,
    ContactSupportComponent,
    TemplateDialogComponent,
    FilterDropdownComponent,
    SFAccountGridComponent,
    MaintenancePopupComponent,
    MaintenanceAlertComponent,
    AssetCategoryEditorComponent,
    ButtonWrapperComponent
  ],
  exports: [
    UserImageComponent,
    FunctionalitiesGridComponent,
    UsecasesGridComponent,
    FunctionalitiesFormComponent,
    UsecasesFormComponent,
    DomainGridComponent,
    ProcessGridComponent,
    GroupGridComponent,
    IndustryGridComponent,
    DemosGridComponent,
    NavbarComponent,
    NavbarFooterComponent,
    HeroImageComponent,
    ContactSupportComponent,
    TemplateDialogComponent,
    FilterDropdownComponent,
    SFAccountGridComponent,
    MaintenancePopupComponent,
    MaintenanceAlertComponent,
    AssetCategoryEditorComponent,
    ButtonWrapperComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    DxDataGridModule,
    DxButtonModule,
    DxToolbarModule,
    DxTextBoxModule,
    DxValidatorModule,
    DxSelectBoxModule,
    DxTagBoxModule,
    DxPopupModule,
    DxLoadIndicatorModule,
    DxScrollViewModule,
    DxProgressBarModule,
    ReactiveFormsModule,
    DxMenuModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    DxDropDownButtonModule,
    DxListModule,
    DxDateBoxModule,
    DxCheckBoxModule,
    DxColorBoxModule,
    MatTooltipModule
  ]
})
export class SharedModule {}
